import { ArrowRightIcon } from '@langchain/untitled-ui-icons';

import { useOnboardingEntrypointOptions } from '@/Pages/Onboarding/hooks/useOnboardingEntrypointOptions';
import { useSegmentAnalyticsContext } from '@/SegmentAnalyticsProvider';
import { Logo } from '@/components/Logo/Logo';
import { Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

import { OnboardingCard } from './OnboardingCard';

export function OnboardingOptions({
  className,
  newTenantId,
  onSkip,
}: {
  onSkip: () => void;
  newTenantId: string | undefined;
  className?: string;
}) {
  const { analytics } = useSegmentAnalyticsContext();
  const options = useOnboardingEntrypointOptions({ newTenantId });
  return (
    <div
      className={cn(
        className,
        `flex h-screen w-screen flex-col items-center justify-start px-[30px] pb-4 pt-[86px] sm:gap-[40px] min-[1400px]:gap-[64px]`
      )}
    >
      <Logo size="lg" className="shrink-0 text-brand-primary" />
      <div className="mt-4 flex flex-col items-center gap-10 text-start">
        <Text variant="h1" weight="normal" className="text-start text-5xl">
          How would you like to start?
        </Text>
      </div>

      <div className="mx-auto grid grid-cols-1 gap-8 self-center overflow-y-auto overflow-x-hidden sm:grid-cols-2 sm:gap-6 min-[1400px]:grid-cols-4 min-[1400px]:gap-6">
        {options.map((option, index) => (
          <OnboardingCard {...option} key={index} />
        ))}
      </div>

      <div className="mx-auto">
        <button
          type="button"
          onClick={() => {
            analytics?.track('Onboarding Skipped');
            onSkip();
          }}
          className="flex items-center gap-1 border-b border-[var(--brand-900)]"
        >
          Skip <ArrowRightIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
